import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import { register as registerServiceWorker } from "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./styles/global.scss";

// 创建事件总线，用于组件间通信
Vue.prototype.$eventBus = new Vue();

Vue.use(ElementUI);

Vue.config.productionTip = false;

// 默认关闭 Service Worker，避免缓存导致验证码/静态资源更新不及时
// 如需开启可在环境变量中设置 VUE_APP_ENABLE_SW=true
if (process.env.VUE_APP_ENABLE_SW === "true") {
  registerServiceWorker();
}

// 创建Vue实例
new Vue({
  router,
  store,
  i18n,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
